// Per-company feature settings (WP4). The API resolves each one for the
// signed-in user (nxstart-api src/constants/company-feature-settings.js) and
// an Evercomm system admin switches them per company without a deploy.
// Every check here is explicit, so a missing field (an older API or a user
// stored before it) reads as the conservative value: production behaviour.

// Excel is always available and is not listed.
export const REPORT_EXTRA_EXPORT_FORMATS = ["word", "pdf", "csv"];

// Same names and order as the API's COMPANY_FEATURE_SETTING_FIELDS.
export const COMPANY_FEATURE_SETTING_FIELDS = [
  "gtoolExportEnabled",
  "hideMoreSolutions",
  "reportFrameworksFilterRequired",
  "reportExportFormats",
  "defaultLanguage",
  "languageDetectionEnabled",
];

export const isGtoolExportEnabled = (user) => user?.gtoolExportEnabled === true;

export const isReportFrameworksFilterRequired = (user) =>
  user?.reportFrameworksFilterRequired === true;

export const canExportFormat = (user, format) => {
  const key = String(format || "").toLowerCase();
  if (key === "excel") return true;
  return (
    REPORT_EXTRA_EXPORT_FORMATS.includes(key) &&
    Array.isArray(user?.reportExportFormats) &&
    user.reportExportFormats.includes(key)
  );
};
